var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Component } from "react";
var items = [
    { form_id: "douglasj_service_wheel_behaviors", title: "Douglas J Service Wheel Behaviors" },
    { form_id: "douglasj_p_for_practical", title: 'Douglas J "P" is for Practical' },
    { form_id: "stlouis_absence_request_form", title: "St. Louis Absence Request Form" },
    { form_id: "stlouis_authorization_additional_hours", title: "St. Louis Authorization for Additional Hours" },
    { form_id: "stlouis_future_professional_missing_time_form", title: "St. Louis Missing Time Form" },
    { form_id: "stlouis_future_professional_makeup_time_request_form", title: "St. Louis Makeup Time Request Form" },
    { form_id: "douglasj_enrollment_agreement_dj", title: "Douglas J Enrollment Agreement" },
    { form_id: "douglasj_enrollment_agreement_chd", title: "College of Hair Design Enrollment Agreement" },
    { form_id: "ibmc_proposal_form", title: "IBMC Program Proposal" },
    {
        form_id: "ogleschool_admission_application",
        title: "Ogle School Admission Application (TX)"
    },
    {
        form_id: "penrose_diamond_glow_consent_form",
        title: "Penrose Diamond Glow Consent Form"
    },
    {
        form_id: "penrose_dermaplaning_informed_consent",
        title: "Penrose Dermaplaning Informed Consent"
    },
    {
        form_id: "penrose_lash_brow_tint_consent_form",
        title: "Penrose Lash Brow Tint Consent Form"
    },
    {
        form_id: "penrose_facial_body_waxing_consent_form",
        title: "Penrose Facial Body Waxing Consent Form"
    },
    {
        form_id: "penrose_r_model_workshop",
        title: "Penrose R Model Workshop"
    },
    {
        form_id: "penrose_understand_form",
        title: "Penrose Understand Form"
    },
    {
        form_id: "penrose_lash_lift_consent_form",
        title: "Penrose Lash Lift Consent Form"
    },
    {
        form_id: "penrose_brow_lamination_consent_form_treatment_log",
        title: "Penrose Brow Lamination Consent Form Treatment Log"
    },
    {
        form_id: "northstar_general_website",
        title: "Northstar General Website"
    },
    {
        form_id: "northstar_recruiter_high_school",
        title: "Northstar Recruiter High School"
    },
    {
        form_id: "northstar_recruiter_non_high_school",
        title: "Northstar Recruiter Non High School"
    },
    {
        form_id: "collectiv_info_cards",
        title: "Collectiv Info Cards"
    },
    {
        form_id: "collectiv_leave_of_absence_form",
        title: "Collectiv Leave of Absence Request Form"
    },
    {
        form_id: "collectiv_info_cards_no_grades",
        title: "Collectiv Info Cards No Grades"
    },
    {
        form_id: "penrose_esthetics_treatment_log",
        title: "Penrose Esthetics Treatment Log"
    },
    {
        form_id: "penrose_esthetics_intake_log",
        title: "Penrose Esthetics Intake Log"
    },
    {
        form_id: "penrose_consent_form_treatment_notes",
        title: "Penrose Consent Form Treatment Notes"
    },
    {
        form_id: "la_enrollment_application_package",
        title: "LA Enrollment Application Package"
    },
    {
        form_id: "ibmc_continuing_education_class_registration",
        title: "IBMC Continuing Education Class Registration"
    },
    {
        form_id: "penrose_student_council_application",
        title: "Penrose Student Council Application"
    },
    {
        form_id: "penrose_diamond_glow_treatment_log",
        title: "Penrose Diamond Glow Treatment Log"
    },
    {
        form_id: "issaco_cte_application",
        title: "ISSACO CTE Application"
    },
    {
        form_id: "turnagegroup_recruiter_high_school",
        title: "Turnagegroup Recruiter High School"
    },
    {
        form_id: "keuneacademy_recruiter_high_school",
        title: "Keuneacademy Recruiter High School"
    },
    {
        form_id: "penrose_recruiter_high_school",
        title: "Penrose Recruiter High School"
    },
    {
        form_id: "mixed_recruiter_high_school",
        title: "Mixed Recruiter High School"
    },
    {
        form_id: "gic_student_leave_of_absence_request",
        title: "GIC Student Leave Of Absence Form Request"
    },
    {
        form_id: "gic_application_admission",
        title: "GIC Application Admission"
    },
    {
        form_id: "pmtsstlouis_application_admission",
        title: "PMTS St. Louis Application Admission"
    },
    {
        form_id: "ssakc_overpayment_form",
        title: "SSAKC Federal Aid Overpayment Receipt"
    }
];
var IndexPage = /** @class */ (function (_super) {
    __extends(IndexPage, _super);
    function IndexPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IndexPage.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement("h1", null,
                "Standalone Forms: ",
                items.length),
            items.map(function (item, index) {
                return (React.createElement(Li, { title: item.title, form_id: item.form_id, token: _this.props.token, index: index, key: index }));
            })));
    };
    return IndexPage;
}(Component));
export { IndexPage };
function Li(_a) {
    var index = _a.index, form_id = _a.form_id, title = _a.title, token = _a.token;
    var url = "/?form_id=".concat(form_id, "&token=").concat(token);
    var pdf_url = "".concat(url, "&pdf");
    return (React.createElement("div", { style: { marginBottom: "10px" } },
        React.createElement("strong", null,
            index + 1,
            ". "),
        React.createElement("a", { href: url }, title),
        " (",
        React.createElement("a", { href: pdf_url }, "PDF"),
        ")"));
}
//# sourceMappingURL=data:application/json;base64,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